<!--
  ערכת פתיחה - the popup a new account gets on its first load: "want us to set up an agreement /
  whatsapp templates / automations for you?". Mounted in App.vue while appData.starterKit.prompt is
  on (the account's owner and admin users only - the server decides). The catalogue comes from
  GET starter-kit, worded for the business (its name and category); every item is a checkbox, a
  group's checkbox ticks the whole group, and יצירה creates what is ticked (POST starter-kit/generate).
  An item the account already has (by name) is shown as such and cannot be ticked again, so the
  popup shown a second time (the root admin's "הצגת החלון שוב") never doubles anything.

  Closing it (לא עכשיו, the X) records a dismissal and the popup does not come back - until the root
  admin asks for it again from the account card. The root admin inside the account (adminPreview)
  can generate, but closing it there decides nothing for the owner.

  The modal has no backdrop-click / Escape close on purpose (noClose): every way out goes through
  notNow(), so a dismissal is never missed.
-->
<template>

    <Modal ref="modal"
           :hideHeader="true"
           :hideFooter="true"
           :noClose="true"
           :customWidth="760">

        <template v-slot:body>

            <div class="starterKit"
                 :class="{ working: phase == 'working' }">

                <button type="button"
                        class="btn-close starterKitClose"
                        aria-label="סגירה"
                        title="לא עכשיו"
                        :disabled="phase == 'working'"
                        @click="notNow"></button>

                <!-- ── pick ── -->
                <div v-if="phase == 'pick' || phase == 'working'">

                    <div class="starterKitHead">
                        <div class="starterKitIcon">
                            <i class="fa-solid fa-wand-magic-sparkles"></i>
                        </div>
                        <h4 class="starterKitTitle">ברוכים הבאים ל-PlanUp!</h4>
                        <p class="starterKitSub">
                            רוצים שנכין לכם תוכן התחלתי?
                            סמנו מה ליצור ונכין אותו
                            <template v-if="business && business.categoryName">מותאם ל{{ business.categoryName }}</template>
                            <template v-else>מותאם לעסק</template>
                            - אפשר לערוך הכול אחר כך.
                        </p>
                    </div>

                    <div v-if="loading"
                         class="starterKitLoading">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                        טוענים...
                    </div>

                    <div v-else-if="loadError"
                         class="starterKitLoading">
                        {{ loadError }}
                        <button class="btn btn-sm btn-light"
                                style="margin-right:8px;"
                                @click="load">נסו שוב</button>
                    </div>

                    <div v-else
                         class="starterKitGroups">

                        <div v-for="group in groups"
                             :key="group.key"
                             class="starterKitGroup"
                             :class="'group-' + group.key">

                            <div class="starterKitGroupHead"
                                 @click="toggleGroup(group)">

                                <div class="planup-checkbox planup-checkbox-purple starterKitCheck"
                                     :class="{ checked: groupState(group) == 'all', partial: groupState(group) == 'some' }"
                                     :data-state="groupState(group)">
                                    <i class="fa fa-check"></i>
                                </div>

                                <i :class="group.icon"
                                   class="starterKitGroupIcon"></i>

                                <div class="starterKitGroupText">
                                    <div class="starterKitGroupName">
                                        {{ group.name }}
                                        <span class="starterKitCount">{{ checkedCount(group) }}/{{ group.items.length }}</span>
                                    </div>
                                    <div class="starterKitGroupDescription">{{ group.description }}</div>
                                </div>

                            </div>

                            <div class="starterKitItems">

                                <label v-for="item in group.items"
                                       :key="item.key"
                                       class="starterKitItem"
                                       :class="{ exists: item.exists, checked: item.checked }"
                                       :data-key="item.key"
                                       @click.prevent="toggleItem(item)">

                                    <div class="planup-checkbox planup-checkbox-purple starterKitCheck"
                                         :class="{ checked: item.checked, disabled: item.exists }">
                                        <i class="fa fa-check"></i>
                                    </div>

                                    <div class="starterKitItemText">
                                        <div class="starterKitItemName">
                                            {{ item.name }}
                                            <span v-if="item.exists"
                                                  class="starterKitExists">קיים כבר</span>
                                        </div>
                                        <div class="starterKitItemDescription">{{ item.description }}</div>
                                    </div>

                                </label>

                            </div>

                        </div>

                    </div>

                    <div v-if="!loading && !loadError"
                         class="starterKitNotes">
                        <div><i class="fa-regular fa-lightbulb"></i> מומלץ לעבור על ההסכם ולהתאים אותו לעסק לפני השימוש.</div>
                        <div><i class="fa-brands fa-whatsapp"></i> הודעות ווטסאפ באוטומציות נשלחות אחרי שמחברים את קו הוואטסאפ בהגדרות.</div>
                        <div v-if="adminPreview"
                             class="starterKitAdminNote">
                            <i class="fa-solid fa-user-shield"></i> תצוגה של מנהל המערכת - "לא עכשיו" כאן לא נרשם לבעל החשבון.
                        </div>
                    </div>

                    <div class="starterKitActions">

                        <button type="button"
                                class="btn btn-primary starterKitGenerate"
                                :disabled="loading || !!loadError || phase == 'working' || totalChecked == 0"
                                @click="generate">
                            <i :class="phase == 'working' ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-wand-magic-sparkles'"></i>
                            <template v-if="phase == 'working'">יוצרים...</template>
                            <template v-else>יצירה<span v-if="totalChecked"> ({{ totalChecked }})</span></template>
                        </button>

                        <button type="button"
                                class="btn btn-light starterKitNotNow"
                                :disabled="phase == 'working'"
                                @click="notNow">לא עכשיו</button>

                    </div>

                </div>

                <!-- ── done ── -->
                <div v-else-if="phase == 'done'"
                     class="starterKitDone">

                    <div class="starterKitHead">
                        <div class="starterKitIcon done">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <h4 class="starterKitTitle">מוכן!</h4>
                        <p class="starterKitSub">
                            <template v-if="result && result.created.length">התוכן נוצר ומחכה לכם:</template>
                            <template v-else>לא נוצר דבר - הכול כבר היה קיים בחשבון.</template>
                        </p>
                    </div>

                    <div class="starterKitSummary">

                        <router-link v-for="line in summaryLines"
                                     :key="line.route"
                                     :to="line.route"
                                     class="starterKitSummaryLine"
                                     :data-route="line.route"
                                     @click.native="finish">
                            <i :class="line.icon"></i>
                            <span class="starterKitSummaryText">{{ line.text }}</span>
                            <span class="starterKitSummaryGo">{{ line.go }} <i class="fa-solid fa-chevron-left"></i></span>
                        </router-link>

                        <div v-if="result && result.skipped.length"
                             class="starterKitSkipped">
                            {{ result.skipped.length }} פריטים דולגו כי כבר היו קיימים:
                            {{ skippedNames }}
                        </div>

                    </div>

                    <div class="starterKitActions">
                        <button type="button"
                                class="btn btn-primary starterKitFinish"
                                @click="finish">סיום</button>
                    </div>

                </div>

            </div>

        </template>

    </Modal>

</template>

<script>

import axiosV2 from '@/core/http/axios_api_v2';

// a moment after the app painted; not on top of another modal / an alert
const FIRST_SHOW_MS = 1800;
const BUSY_RETRY_MS = 2500;
const BUSY_MAX_TRIES = 40;

function screenIsBusy() {
    if (document.querySelector('.modal.show'))
        return true;
    if (document.querySelector('.swal2-container.swal2-shown'))
        return true;
    if (document.querySelector('.homeScreenPrompt'))
        return true;
    // a presentation the customer is looking at (מצב תצוגה ללקוח)
    if (document.querySelector('.customerPresentation, .inventoryPresentation'))
        return true;
    return !!document.querySelector('.accountFrozenModal');
}

export default {

    name: 'StarterKitModal',

    data() {
        return {
            phase: 'pick',
            loading: true,
            loadError: '',
            business: null,
            adminPreview: false,
            groups: [],
            result: null,
            shown: false,
            timers: [],
        }
    },

    computed: {

        totalChecked() {
            let n = 0;
            this.groups.forEach(group => group.items.forEach(item => { if (item.checked) n++; }));
            return n;
        },

        skippedNames() {
            return this.result ? this.result.skipped.map(row => row.name).join(', ') : '';
        },

        // one line per kind that was created, each leading to its page
        summaryLines() {

            if (!this.result)
                return [];

            let lines = [];
            let created = this.result.created;
            let count = kind => created.filter(row => row.kind == kind).length;

            if (count('document'))
                lines.push({ route: '/documents', icon: 'fa-solid fa-file-signature', text: 'הסכם הזמנת שירות - תבנית תנאי הסכם שמצורפת להזמנה', go: 'לתבניות המסמכים' });

            if (count('messageTemplate'))
                lines.push({ route: '/messageTemplates', icon: 'fa-brands fa-whatsapp', text: count('messageTemplate') + ' תבניות ווטסאפ לשליחה מכרטיס הלקוח', go: 'לתבניות ההודעות' });

            if (count('automation'))
                lines.push({ route: '/automations', icon: 'fa-solid fa-wand-magic-sparkles', text: count('automation') + ' אוטומציות, פעילות - אפשר לכבות או לערוך כל אחת', go: 'לאוטומציות' });

            return lines;

        },

    },

    mounted() {

        this.adminPreview = !!(this.$store.state.starterKit && this.$store.state.starterKit.adminPreview);

        this.load();

        this.later(() => this.showWhenQuiet(0), FIRST_SHOW_MS);

    },

    beforeDestroy() {
        this.timers.forEach(timer => clearTimeout(timer));
    },

    methods: {

        later(fn, ms) {
            this.timers.push(setTimeout(fn, ms));
        },

        showWhenQuiet(tries) {

            if (this.shown)
                return;

            if (tries < BUSY_MAX_TRIES && screenIsBusy()) {
                this.later(() => this.showWhenQuiet(tries + 1), BUSY_RETRY_MS);
                return;
            }

            this.shown = true;

            if (this.$refs.modal)
                this.$refs.modal.show();

        },

        load() {

            this.loading = true;
            this.loadError = '';

            axiosV2('starter-kit').then(res => {

                let data = (res && res.data) || {};

                this.business = data.business || null;
                this.adminPreview = !!data.adminPreview || this.adminPreview;

                this.groups = (data.groups || []).map(group => ({
                    key: group.key,
                    name: group.name,
                    description: group.description,
                    icon: group.icon,
                    route: group.route,
                    items: (group.items || []).map(item => ({
                        key: item.key,
                        kind: item.kind,
                        name: item.name,
                        description: item.description,
                        exists: !!item.exists,
                        checked: !item.exists,
                    })),
                }));

                this.loading = false;

            }).catch(() => {
                this.loading = false;
                this.loadError = 'הטעינה נכשלה';
            });

        },

        groupState(group) {

            let available = group.items.filter(item => !item.exists);

            if (!available.length)
                return 'none';

            let checked = available.filter(item => item.checked).length;

            if (checked == 0)
                return 'none';

            return checked == available.length ? 'all' : 'some';

        },

        checkedCount(group) {
            return group.items.filter(item => item.checked).length;
        },

        toggleGroup(group) {

            if (this.phase == 'working')
                return;

            let on = this.groupState(group) != 'all';

            group.items.forEach(item => {
                if (!item.exists)
                    item.checked = on;
            });

        },

        toggleItem(item) {

            if (this.phase == 'working' || item.exists)
                return;

            item.checked = !item.checked;

        },

        generate() {

            let keys = [];
            this.groups.forEach(group => group.items.forEach(item => { if (item.checked) keys.push(item.key); }));

            if (!keys.length || this.phase == 'working')
                return;

            this.phase = 'working';

            axiosV2.post('starter-kit/generate', { items: keys }).then(res => {

                let data = (res && res.data) || {};

                this.result = { created: data.created || [], skipped: data.skipped || [] };

                this.applyToStore(data.rows || {});

                // the store's prompt flag stays on until close(): App.vue's v-if would unmount
                // this modal before the done view is seen
                this.phase = 'done';

            }).catch(err => {

                this.phase = 'pick';
                this.AlertError((err && err.message) || 'היצירה נכשלה - נסו שוב');

            });

        },

        // the pages that list these read the store (loaded once with appData): put the new rows
        // in, so they show without a reload
        applyToStore(rows) {

            let state = this.$store.state;

            (rows.messageTemplates || []).forEach(row => {
                if (Array.isArray(state.messageTemplates) && !state.messageTemplates.find(t => t.id == row.id))
                    state.messageTemplates.push(row);
            });

            (rows.documents || []).forEach(row => {
                if (state.documents && Array.isArray(state.documents.termsTemplates) && !state.documents.termsTemplates.find(d => d.id == row.id))
                    state.documents.termsTemplates.push(row);
            });

        },

        // לא עכשיו / the X: the popup does not come back (the root admin's look decides nothing)
        notNow() {

            if (this.phase == 'working')
                return;

            if (!this.adminPreview)
                axiosV2.post('starter-kit/dismiss', {}).catch(() => { });

            this.close();

        },

        finish() {
            this.close();
        },

        close() {

            if (this.$refs.modal)
                this.$refs.modal.hide();

            // unmounts this component (App.vue's v-if)
            this.later(() => {
                if (this.$store.state.starterKit)
                    this.$store.state.starterKit.prompt = false;
            }, 250);

        },

    },

}

</script>

<style scoped>

.starterKit {
    position: relative;
    padding: 4px 4px 0;
}

.starterKitClose {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
}

.starterKitHead {
    text-align: center;
    padding: 6px 28px 14px;
}

.starterKitIcon {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    margin: 0 auto 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #fff;
    background: linear-gradient(135deg, #7650c4, #ab8ce4);
    box-shadow: 0 6px 16px rgba(118, 80, 196, 0.28);
}

.starterKitIcon.done {
    background: linear-gradient(135deg, #28a745, #5fd27a);
    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.28);
}

.starterKitTitle {
    font-weight: 700;
    margin: 0 0 6px;
    font-size: 22px;
}

.starterKitSub {
    margin: 0;
    color: #555;
    font-size: 15px;
}

.starterKitLoading {
    text-align: center;
    color: #777;
    padding: 30px 0;
}

.starterKitGroups {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 52vh;
    overflow-y: auto;
    padding: 2px;
}

.starterKitGroup {
    /* a flex child of the scrolling column: never shrink (it would clip its own items) */
    flex: 0 0 auto;
    border: 1px solid #e6e2f2;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
}

.starterKitGroupHead {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    background: #f7f5fc;
    cursor: pointer;
    user-select: none;
}

.starterKitGroupIcon {
    font-size: 20px;
    color: #7650c4;
    width: 26px;
    text-align: center;
}

.starterKitGroupText {
    flex: 1;
    min-width: 0;
}

.starterKitGroupName {
    font-weight: 700;
    font-size: 16px;
}

.starterKitCount {
    display: inline-block;
    margin-right: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #7650c4;
    background: #ede8f8;
    border-radius: 10px;
    padding: 1px 8px;
    vertical-align: middle;
}

.starterKitGroupDescription {
    color: #666;
    font-size: 13px;
    margin-top: 2px;
}

.starterKitItems {
    display: flex;
    flex-direction: column;
}

.starterKitItem {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 9px 14px 9px 14px;
    margin: 0;
    border-top: 1px solid #f0edf7;
    cursor: pointer;
    font-weight: normal;
}

.starterKitItem:hover {
    background: #fbfaff;
}

.starterKitItem.exists {
    cursor: default;
    opacity: 0.6;
}

.starterKitItemText {
    flex: 1;
    min-width: 0;
}

.starterKitItemName {
    font-weight: 600;
    font-size: 14px;
}

.starterKitExists {
    display: inline-block;
    margin-right: 8px;
    font-size: 11px;
    font-weight: 500;
    color: #666;
    background: #eee;
    border-radius: 10px;
    padding: 1px 8px;
    vertical-align: middle;
}

.starterKitItemDescription {
    color: #777;
    font-size: 13px;
    margin-top: 1px;
}

.starterKitCheck {
    flex: 0 0 auto;
    margin-top: 1px;
}

.starterKitCheck.partial {
    background: #c9b8ec;
    border-color: #c9b8ec;
}

.starterKitCheck.partial i {
    opacity: 1;
    color: #fff;
}

.starterKitCheck.disabled {
    opacity: 0.5;
}

.starterKitNotes {
    margin-top: 12px;
    color: #666;
    font-size: 13px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.starterKitNotes i {
    color: #7650c4;
    width: 18px;
    text-align: center;
}

.starterKitAdminNote {
    color: #a05a00;
}

.starterKitAdminNote i {
    color: #a05a00;
}

.starterKitActions {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 16px;
    padding-bottom: 4px;
}

.starterKitActions .btn {
    min-width: 140px;
}

.starterKitSummary {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 4px 0 6px;
}

.starterKitSummaryLine {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #e6e2f2;
    border-radius: 12px;
    color: #333;
    text-decoration: none;
    background: #fff;
}

.starterKitSummaryLine:hover {
    background: #f7f5fc;
    color: #333;
}

.starterKitSummaryLine > i {
    font-size: 20px;
    color: #7650c4;
    width: 26px;
    text-align: center;
}

.starterKitSummaryText {
    flex: 1;
    font-weight: 600;
}

.starterKitSummaryGo {
    color: #7650c4;
    font-size: 13px;
    white-space: nowrap;
}

.starterKitSkipped {
    color: #777;
    font-size: 13px;
    padding: 4px 2px;
}

@media (max-width: 767px) {

    .starterKitGroups {
        max-height: 48vh;
    }

    .starterKitActions {
        flex-direction: column;
    }

    .starterKitSummaryGo {
        display: none;
    }

}

</style>
